<!--
Copyright (c) 2022-2023 Antmicro <www.antmicro.com>

SPDX-License-Identifier: Apache-2.0
-->

<!-- eslint-disable max-len -->
<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_1486_1332)">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M2.36204 3.63607L8.72565 9.99968L2.36204 16.3633L3.63483 17.6361L9.99844 11.2725L16.362 17.6361L17.6348 16.3633L11.2712 9.99968L17.6348 3.63607L16.362 2.36328L9.99844 8.72688L3.63483 2.36328L2.36204 3.63607ZM2.5 10.6993C2.8866 10.6993 3.2 10.3859 3.2 9.9993C3.2 9.6127 2.8866 9.2993 2.5 9.2993C2.1134 9.2993 1.8 9.6127 1.8 9.9993C1.8 10.3859 2.1134 10.6993 2.5 10.6993ZM4.8331 10.8993C4.47179 11.8353 3.56344 12.4993 2.5 12.4993C1.11929 12.4993 0 11.38 0 9.9993C0 8.61859 1.11929 7.4993 2.5 7.4993C3.56344 7.4993 4.47179 8.16329 4.8331 9.0993H6.5V10.8993H4.8331ZM17.5 10.6993C17.8866 10.6993 18.2 10.3859 18.2 9.9993C18.2 9.6127 17.8866 9.2993 17.5 9.2993C17.1134 9.2993 16.8 9.6127 16.8 9.9993C16.8 10.3859 17.1134 10.6993 17.5 10.6993ZM17.5 12.4993C18.8807 12.4993 20 11.38 20 9.9993C20 8.61859 18.8807 7.4993 17.5 7.4993C16.4366 7.4993 15.5282 8.16329 15.1669 9.0993H13.5V10.8993H15.1669C15.5282 11.8353 16.4366 12.4993 17.5 12.4993Z" fill="white"/>
        </g>
        <defs>
            <clipPath id="clip0_1486_1332">
                <rect width="20" height="20" fill="white"/>
            </clipPath>
        </defs>
    </svg>
</template>
